let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("daGTo")).then(() => parcelRequire('cT2BR'));